import type { PropsWithChildren } from 'react'
import * as React from 'react'
import styled from 'styled-components'
import clsx from 'clsx'
import _BaseLabel from './_BaseLabel'
import { REBRAND_PALETTE_CLASS } from 'lib/theme/paletteVersion'

const NeutralLabelElement = styled(_BaseLabel)`
  background-color: var(--palette-neutral-surface-normal-background);
  border-color: var(--palette-neutral-surface-light-foreground);
  color: var(--palette-neutral-surface-normal-contrast);

  body.${REBRAND_PALETTE_CLASS} & {
    color: var(--palette-highlight-primary-dark-foreground);
  }
`

interface Props {
  className?: string
  startIcon?: React.ReactNode
  endIcon?: React.ReactNode
  ref?: React.Ref<HTMLSpanElement>
  format?: React.ComponentProps<typeof _BaseLabel>['format']
}

/**
 * Documentation: <https://aussiecommerce.atlassian.net/wiki/spaces/UXUI/pages/4504289338/Label>
 */
function NeutralLabel({ className, ...labelProps }: PropsWithChildren<Props>) {
  return <NeutralLabelElement
    className={clsx(
      className,
    )}
    {...labelProps}
  />
}

export default NeutralLabel
